export const SET_CUSTOM_METADATA = '@@customMetadata/set';
export const ADD_CUSTOM_METADATA = '@@customMetadata/add';
export const EDIT_CUSTOM_METADATA = '@@customMetadata/edit';
export const DELETE_CUSTOM_METADATA = '@@customMetadata/delete';
